import React from 'react'

import { Link } from 'gatsby'
import { createRoot } from 'react-dom/client'
import { PrismicProvider } from '@prismicio/react'
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews'

import { SharedScripts } from './gatsby-shared'

import './src/stylesheets/main.scss'
import { linkResolver } from './src/utils/linkResolver'
import { onRouteUpdateGtmEvent } from './src/utils/gtmEvents'
import { repositoryConfigs } from './src/utils/prismicPreviews'
import HeaderDataContextProvider from './src/hooks/useHeaderData'

export const onRouteUpdate = (_, pluginOptions) => {
  if (
    process.env.NODE_ENV === `production` ||
    pluginOptions.includeInDevelopment
  ) {
    // wrap inside a timeout to ensure the title has properly been changed
    setTimeout(() => {
      onRouteUpdateGtmEvent(pluginOptions)
    }, 50)
  }
}

export const onInitialClientRender = (_, pluginOptions) => {
  if (
    process.env.NODE_ENV === `production` ||
    pluginOptions.includeInDevelopment
  ) {
    // wrap inside a timeout to ensure the title has properly been changed
    setTimeout(() => {
      const data = pluginOptions.dataLayerName
        ? window[pluginOptions.dataLayerName]
        : window.dataLayer
      const eventName = pluginOptions.routeChangeEventName
        ? pluginOptions.routeChangeEventName
        : `gatsby-page-view`

      data.push({ event: eventName })
    }, 1000)
  }
}

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = createRoot(container)
    root.render(element)
  }
}

export const wrapRootElement = ({ element }) => (
  <PrismicProvider
    linkResolver={linkResolver}
    internalLinkComponent={({ href, ...props }) => (
      <Link to={href} {...props} />
    )}
  >
    <PrismicPreviewProvider repositoryConfigs={repositoryConfigs}>
      <HeaderDataContextProvider>{element}</HeaderDataContextProvider>
      <SharedScripts />
    </PrismicPreviewProvider>
  </PrismicProvider>
)
